import * as React from 'react';
import classnames from 'classnames';
import styles from './Divider.styl';
const Divider = ({ className }) => (React.createElement("span", { className: classnames(styles.divider, className) }));
Divider.defaultProps = {
    className: ''
};
export default Divider;
